module.exports = require("lodash/orderBy");


//////////////////
// WEBPACK FOOTER
// external "lodash/orderBy"
// module id = 42
// module chunks = 0